import { VerticalContainer } from "@shared/designSystem/Containers"
import { SmallText, Text } from "@shared/designSystem/Texts"
import designSystemStyles from "@shared/styles/designSystemStyles"

interface DetailFieldProps {
    label: string
    value?: string | number | null
    emptyValue?: string
}

export const DetailField: React.FC<DetailFieldProps> = ({
    label,
    value,
    emptyValue = "N/D".localized()
}) => {
    const resolvedValue = value !== undefined && value !== null && String(value).trim() !== ""
        ? String(value)
        : emptyValue

    return (
        <VerticalContainer width="100%" gap={designSystemStyles.gapSm}>
            <SmallText text={label} color={designSystemStyles.colorText} />
            <Text text={resolvedValue} />
        </VerticalContainer>
    )
}

export default DetailField
